import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";

// AuthProvider handles the code exchange; this page shows progress and then
// hands the router back to "/" — AuthProvider's history.replaceState alone
// doesn't notify react-router, which is why this must render a <Navigate>.
export function Callback() {
  const { loading, error } = useAuth();
  if (loading) {
    return (
      <main className="home">
        <p>Signing you in…</p>
      </main>
    );
  }
  if (error) {
    return (
      <main className="home">
        <p className="error">Sign-in failed: {error}</p>
      </main>
    );
  }
  return <Navigate to="/" replace />;
}
